// store/thunks/auth/resendPhoneCodeThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { VerificationDTO } from '@/types/DTOs';

export const resendPhoneCodeThunk = createAppAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/resendPhoneCode',
  async(_, { extra: { authService }, rejectWithValue }) => {

    try {
      return await authService.resendPhoneCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to resend phone code';
      return rejectWithValue({ message });
    }
  }
);
